<template>
  <div class="row items-center justify-center" v-if="loading">
    <Loading />
  </div>
  <div
    v-else-if="groupDetailWithPoints && groupDetailWithPoints.length"
    class="relative-position"
    style="user-select: none"
  >
    <div class="fit" id="_tlqn_admin_sg_detail_distribution"></div>
    <LockMask
      v-if="adminStatusStore[REMOVING_GROUP_MEMBERS]"
      lock-tip="正在操作样本组内的样本"
    />
    <div
      style="position: absolute; right: 10px; top: 10px"
      class="bmap-custom-marker-controller"
    >
      <div
        class="bmap-custom-marker-control"
        :class="{
          'bmap-custom-marker-control-active': selectedType === type.key_prefix,
        }"
        v-for="type in pointType"
        :key="type.key_prefix"
        @click="selectedType = type.key_prefix"
      >
        {{ type.label }}
      </div>
    </div>
  </div>
  <div v-else class="row items-center justify-center">
    <Empty
      :text="
        groupDetail ? '当前样本组未找到任何地理坐标点' : '请先选择一个样本组'
      "
    />
  </div>
</template>

<script>
import BMapMixin from "@/mixins/bmap.mixin";
import SampleGroupMixin from "../sample-group.mixin";
import AdminCommonStatus from "../../mixins/status.mixin";
import { REMOVING_GROUP_MEMBERS } from "@/status/admin.status";

export default {
  mixins: [BMapMixin, SampleGroupMixin, AdminCommonStatus],
  components: {
    Loading: () => import("@/components/Loading"),
    Empty: () => import("@/components/Empty"),
    LockMask: () => import("@/components/Mask"),
  },
  data() {
    return {
      loading: false,
      REMOVING_GROUP_MEMBERS,
      pointType: [
        { key_prefix: "dom", label: "注册地址" },
        { key_prefix: "addr", label: "经营地址" },
        { key_prefix: "entname", label: "地图检索地址" },
      ],
      selectedType: undefined,
    };
  },

  watch: {
    groupDetail: {
      immediate: true,
      handler(detail) {
        this.selectedType = undefined;
        if (detail) {
          this.selectedType = "dom";
        }
      },
    },

    selectedType(newType, oldType) {
      if (newType) {
        this.renderMap();
      }
    },
  },

  computed: {
    groupDetailWithPoints() {
      const { selectedType, groupDetail } = this;
      if (!groupDetail || !selectedType) return [];
      const filtered = this.groupDetail.samples.filter(
        (sample) =>
          sample.detail[`${selectedType}_lon`] &&
          sample.detail[`${selectedType}_lat`]
      );
      return filtered;
    },
  },

  methods: {
    async renderMap() {
      this.loading = false;
      await this.renderSamplesGroupByStatus(
        this.groupDetailWithPoints,
        this.selectedType,
        "_tlqn_admin_sg_detail_distribution",
        (bmapPointCollection) => {
          bmapPointCollection.addEventListener("click", (event) => {
            const { point } = event;
            const { group } = point;
            const { detail } = group;

            if (this.$route.query._gs && this.$route.query._gs === detail.id)
              return;
            this.$router.replace({
              query: {
                ...this.$route.query,
                _gs: group.id,
                r: new Date().getTime(),
              },
            });
          });
        }
      );
    },
  },
};
</script>
